import { cn } from '@/lib/utils';
import { HTMLAttributes } from 'react';

type SkeletonProps = HTMLAttributes<HTMLDivElement>;

export const Skeleton = ({ className, ...props }: SkeletonProps) => {
  return (
    <div
      className={cn(
        'bg-gray-400 animate-pulse rounded inline-block',
        className,
      )}
      {...props}
    />
  );
};
